import FW from '../fw/fw';


export default class StreamingHelpers {

  #rmp;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  static getCodecLabel(level, span) {
    let codecLabel = '';
    if (/^avc/i.test(level.videoCodec)) {
      codecLabel = 'H.264';
    } else if (/^(hvc|hev)/i.test(level.videoCodec)) {
      codecLabel = 'H.265';
    } else if (/^(dvh|dva|dav)/i.test(level.videoCodec)) {
      codecLabel = 'Dolby V';
    } else if (/^(vp09|vp9)/i.test(level.videoCodec)) {
      codecLabel = 'VP9';
    } else if (/^(vp08|vp8)/i.test(level.videoCodec)) {
      codecLabel = 'VP8';
    } else if (/^av01/i.test(level.videoCodec)) {
      codecLabel = 'AV1';
    } else if (/^(vvc|vvi)/i.test(level.videoCodec)) {
      codecLabel = 'H.266';
    }
    FW.setText(span, ` | ${codecLabel}`);
  }

  static getBandwidth(bandwidth, bitrateDataDisplayed) {
    const kbps = Math.round(bandwidth / 1000);
    const mbps = FW.precisionRound(kbps / 1000, 1);
    let span = document.createElement('span');
    if (bitrateDataDisplayed === 'kbps') {
      span.textContent = kbps + ' kbps';
    } else if (bitrateDataDisplayed === 'mbps') {
      span.textContent = mbps + ' Mbps';
    }
    return span;
  }

  static getLevelHeight(level) {
    let result = '';
    let sup = '';
    const span = document.createElement('span');
    if (typeof level.width === 'number' && level.width > 0) {
      if (level.width >= 7680) {
        sup = '8K';
      } else if (level.width >= 5120) {
        sup = '5K';
      } else if (level.width >= 3840) {
        sup = '4K';
      } else if (level.width > 1920) {
        sup = '2K';
      } else if (level.width >= 1280) {
        sup = 'HD';
      }
    }
    if (typeof level.height === 'number' && level.height > 0) {
      result += level.height.toString() + 'p';
      if (typeof level.frameRate === 'number' && level.frameRate > 30) {
        result += (Math.round(level.frameRate)).toString();
      }
      span.textContent = result;
      if (sup) {
        const supElement = FW.createElement('sup', 'rmp-sup', sup);
        span.appendChild(supElement);
      }
    }
    return span;
  }

  static filterNativeTextTracks(textTracks) {
    const validTextTracks = [];
    if (textTracks.length > 0) {
      const typesPattern = /(captions|subtitles|subtitle|caption|text)/i;
      for (let i = 0, len = textTracks.length; i < len; i++) {
        if (textTracks[i].kind && typesPattern.test(textTracks[i].kind)) {
          validTextTracks.push(textTracks[i]);
        }
      }
      const lngList = [];
      const finalValidTextTracks = [];
      for (let i = 0, len = validTextTracks.length; i < len; i++) {
        const lng = validTextTracks[i].language;
        if (lng) {
          if (lngList.length === 0) {
            lngList.push(lng);
            finalValidTextTracks.push(validTextTracks[i]);
          } else {
            if (lngList.includes(lng)) {
              continue;
            } else {
              lngList.push(lng);
              finalValidTextTracks.push(validTextTracks[i]);
            }
          }
        } else {
          finalValidTextTracks.push(validTextTracks[i]);
        }
      }
      return finalValidTextTracks;
    }
    return validTextTracks;
  }

  updateQualityModuleIcon(quality) {
    const hdPattern = /HD/;
    const twoKPattern = /2K/;
    const fourKPattern = /4K/;
    const fiveKPattern = /5K/;
    const eightKPattern = /8K/;
    const qualityText = quality.textContent;
    const qualityHDElement = this.#rmp.dom.qualityHD;
    if (qualityHDElement) {
      if (eightKPattern.test(qualityText)) {
        FW.setText(qualityHDElement, '8K');
        qualityHDElement.style.display = 'inline';
      } else if (fiveKPattern.test(qualityText)) {
        FW.setText(qualityHDElement, '5K');
        qualityHDElement.style.display = 'inline';
      } else if (fourKPattern.test(qualityText)) {
        FW.setText(qualityHDElement, '4K');
        qualityHDElement.style.display = 'inline';
      } else if (twoKPattern.test(qualityText)) {
        FW.setText(qualityHDElement, '2K');
        qualityHDElement.style.display = 'inline';
      } else if (hdPattern.test(qualityText)) {
        FW.setText(qualityHDElement, 'HD');
        qualityHDElement.style.display = 'inline';
      } else {
        qualityHDElement.style.display = 'none';
      }
    }
  }

  selectRendition(index, event) {
    FW.eventStopPrevent(event);
    this.#rmp.rmpUIManagement.showChrome();
    this.#rmp.quality = index - 1;
    this.#rmp.rmpModuleManagement.close('quality');
  }

  selectAudioTrack(index, event) {
    FW.eventStopPrevent(event);
    this.#rmp.rmpUIManagement.showChrome();
    this.#rmp.audioTrack = index;
    this.#rmp.rmpModuleManagement.close('audio');
  }

  setUpAbrUI() {
    this.#rmp.rmpModuleManagement.appendToControlBar('quality');
    this.#rmp.rmpModuleManagement.appendOverlay('quality');
    // auto button
    let autoLabel;
    const labels = this.#rmp.labels;
    if (labels.hint.auto) {
      autoLabel = labels.hint.auto;
    }
    this.#rmp.dom.qualityAuto = FW.createElement(
      'button',
      'rmp-button rmp-overlay-level rmp-color-bg rmp-overlay-level-active rmp-q0',
      autoLabel,
      this.#rmp.rtl,
      true
    );
    this.#rmp.rmpAccessible.button(this.#rmp.dom.qualityAuto, autoLabel, true);
    this.#rmp.dom.qualityOverlayLevelsArea.appendChild(this.#rmp.dom.qualityAuto);
  }

}
